/* eslint-disable import/no-anonymous-default-export */
export default {
  common: {
    keywordSearch: "検索するキーワードを入力",
    noResults: "結果がありません。",
    actions: "アクション",
    add: "追加",
    edit: "編集",
    view: "見方",
    tag: "タブ",
    back: '戻る',
    collapseMenu: "折りたたみメニュー",
    save: "保存",
    cancel: "キャンセル",
    delete: "削除",
    deleteConfirmMsg: "本当に削除しますか?",
    no: "いいえ",
    yes: "はい",
    noDataAvailable: "使用可能なデータがありません",
    pagination: {
      rowsPerPage: "Rows per page:",
      range: "{{from}}–{{to}} of {{total}}",
      page: "Page",
      pageInput: "Page number",
      ofPages: "of {{total}}",
      firstPage: "First page",
      previousPage: "Previous page",
      nextPage: "Next page",
      lastPage: "Last page",
      invalidPage: "Enter a page from 1 to {{total}}",
    },
    reason: "理由",
    createdBy: "作成者",
    modifiedBy: "変更者",
    saveChanges: "変更を保存",
    close: "オフ",
    pleaseEnter: "入力してください。。。",
    globalSmartSearch: "検索するキーワードを入力",
    loadingText: "データをロードしています。少々お待ちください。",
    collapse: "クラッシュ",
    expand: "拡大",
    search: "検索けんさく",
    paracetamol: "アセトアミノフェン",
    clone: "クローン作成",
    disable: "だめに",
    enable: "可能にする",
    manageWorkflow: "ワークフローの管理",
    publish: "出版",
    saveAsDocument: "ドキュメントとして保存",
    preview: "プレビュー",
    download: "ダウンロード",
    summarizeIt: "まとめて",
    translateDocument: "ドキュメントの翻訳",
    tenant: "宿泊客",
    languageSwitch: "言語切り替え",
    ac: "管理センター",
    logout: "ログアウト",
    revert: "リストア",
    list: "リスト",
    showDeletedRecords: "削除されたレコードを表示",
    recordID: "レコードID",
    recordName: "レコード名",
    description: "説明",
    status: "ポジション",
    information: "情報＃ジョウホウ＃",
    createdDate: "作成日",
    modifiedDate: "変更日",
    basicInformation: "基本情報",
    details: "詳細",
    level: "数量",
    update: "現代化する",
    lock: "ロック",
    unlock: "ロック解除",
    typeofAssociation: "協会タイプ",
    recordDeleteTip:
      "レコード破り <b>削除できません </b> 以下の依存関係があるからです。",
    recordStatusTip:
      "ポジション <b>変更できません </b> 以下の依存関係があるからです。",
    comments: "コメント",
    clear: "はっきりした",
    apply: "申し込み",
    clearFilter: "フィルタをクリア",
    downloadPDF: "PDFダウンロード",
	  downloadCSV: "CSVダウンロード",
	  downloadExcel: "Excelダウンロード",
    tip: {
      addSuccess: "追加成功。",
      addFailed: "追加に失敗しました。",
      updateSuccess: "更新に成功しました。",
      updateFailed: "更新に失敗しました。",
      revertSuccess: "リストア成功。",
      revertFailed: "リストアに失敗しました。",
      deleteSuccess: "削除に成功しました。",
      deleteFailed: "削除に失敗しました。",
      deletion: "削除理由を入力してください。",
      limit_2000: "2000文字を超える最大制限を入力しました。",
      selectOneItem: "アイテムを一つ選択してください。",
      selectTarget: "まず、ターゲットを選択してください。",
    },
    createdDateAndTime: "作成日時",
    modifiedDateAndTime: "修正日時",
    audit: "監査",
    deleteSelected: "選択したものを削除",
    next: "次",
    importInfo: "インポート情報",
    importTips: "注：サポートされているファイルフォーマット.xls，.xlsx",
    downloadTemplate: "テンプレートのダウンロード",
    unsavedChange: {
      title: "保存されてない変更",
      content: "このページを離れてもよろしいですか？ 保存されていない変更はすべて失われます。"
    },
    importFile: {
      tips: {
        noFileChoose: "ファイルを選択するか、「キャンセル」をクリックして画面を終了してください。",
        fileFormatError: "ファイルタイプの使用は許可されていません。",
        fileDuplicate: "重複するファイルをチェックして削除してください。",
        importingDate: "私たちはあなたのデータをインポートしています。数秒待ってください。",
        importSuccess: "ファイルのインポートに成功しました。",
        uploadSuccess: "ファイルは正常にアップロードされました。",
        importFailure: "失敗数"
      }
    },
    businessRule: {
      title: "ビジネスルールの設定",
      source: 'ソース',
      name: '名前',
      field: 'フィールド',
      rule: 'ルール',
      values: '値',
      required: '{{fieldName}}は必須です',
      exists: '存在する',
      equals: '等しい',
      in: '含まれる'
    }
  },
  validation: {
    isRequired: "必須"
  },
  commonFilter: {
    filters: "フィルター",
    filterby: "フィルター条件",
    select: "選択",
    search: "検索",
    clearFilters: "フィルターをクリア"
  },
  menu: {
    searchModule: "検索モジュール",
    modules: "モジュール",
    uam: "ユーザーアクセス管理",
    users: "ユーザー",
    roles: "ロール＃ロール＃",
    userGroups: "ユーザー・グループ",
    accessControl: "アクセス制御",
    cm: "構成管理",
    menuManager: "メニューマネージャ",
    formManager: "フォームマネージャ",
    gridManager: "グリッド・マネージャ",
    audit: "監査レポート",
    notifications: "通知",
    templates: "テンプレート",
    payloads: "ペイロード",
    tasks: "タスク",
    history: "履歴",
    importACL: "アクセス制御のインポート",
    importUser: "ユーザーのインポート",
    importGroup: "ユーザー・グループのインポート",
    importRole: "ロールのインポート",
    workflowManager: "ワークフローマネージャ",
    knowledgeManager: "ナレッジマネージャ",
  },
  notification: {
    domainName: "ドメイン名",
    moduleName: "モジュール名",
    fieldName: "フィールド名",
    templateName: "テンプレート名",
    createdDate: "作成日",
    createdDateAndTime: "作成日時",

    payloads: "ペイロード",
    payloadId: "ペイロードID",
    notificationPayload: "通知ペイロード",
    remarks: "備考",
    status: "ステータス",

    tasks: "タスク",
    taskId: "タスクID",
    taskType: "タスクタイプ",
    scheduledDate: "過去の計画日",
    lastScheduledDate: "来る予定日",
    endDate: "終了日",

    history: "履歴",
    notificationContent: "通知内容",
    receiver: "受信者",

    Templates: "テンプレート",
    cancelTask: "タスクをキャンセル",
    tips: {
      copiedSuccess: "コピー成功",
      cancelSucess: "タスクが正常にキャンセルされました",
      cancelConfirm: '選択したタスクは<b class="alert-text">キャンセル</b>されます。<br />続行しますか？',
    },

    basic: {
      tab: "テンプレート設定",
      title: "通知を作成するテンプレートのリスト",
      addTemplate: "テンプレートを追加",
      editTemplate: "テンプレートを編集",
      viewTemplate: "テンプレートを表示",
      templatedescription: "テンプレートの説明",
      notificationType: "通知タイプ",
      notificationFrequency: "Notification Frequency",
      notificationChannels: "通知チャンネル",
      condition: "条件",
      interval: "間隔",
      intervalUnit: "間隔単位",
      frequency: "はっせい",
      notificationDisabled: "通知無効",
      frequencyNeedsCondition: "このモジュールの Frequency テンプレートは、条件を 1 つ以上追加すると有効にできます。",
      deleteTemplate: "テンプレートを削除",
      tips: {
        deleteSuccess: "テンプレートが正常に削除されました",
        deleteOne: "削除するデータを選択してください",
        deleteConfirm: '選択したテンプレートは<b class="alert-text">削除</b>されます。<br />続行しますか？',
        updatedSuccess: "テンプレートが正常に更新されました",
        addSuccess: "テンプレートが正常に追加されました"
      },
      // English placeholders — replace with proper Japanese when available
      recurringPattern: {
        title: "Recurring Pattern",
        description: "Define when and how often this notification should run.",
        recurrenceLabel: "Recurrence:",
        firstSendLabel: "First scheduled send:",
        notApplicable: "Not applicable.",
        recurringType: "Recurring Type",
        occurrencePlaceholder: "please select Occurence from 1 to 100 only",
        intervalPlaceholder: "1-100",
        unitPlaceholder: "Unit",
        frequencyType: "Frequency Type",
        frequencyTypePlaceholder: "please select Frequency Type",
        startDate: "Start Date",
        endDate: "End Date",
        sendTime: "Email Send Time",
        timeZone: "Time Zone",
        sendTimeHint:
          "The email may not go out at this exact time. A short delay can happen while the system prepares and sends it.",
        everyWeeks: "Every (week(s))",
        on: "On",
        end: "End",
        occurrences: "occurrences",
        repeatFrequency: "Repeat Frequency",
        day: "Day",
        ofEvery: "of every",
        months: "month(s)",
        the: "The",
        ok: "OK",
        continue: "Continue",
        shortMonthTitle: "Some months have fewer than {{day}} days.",
        shortMonthBody: "In those months the notification will fallback to send on the last valid day of the month.",
        noValidSendTitle: "Warning",
        noValidSendBody: "The configured frequency yields no valid send dates within the selected Start and End Date range.",
        types: {
          occurrence: "Occurrence",
          frequency: "Frequency",
        },
        frequencyTypes: {
          weekly: "Weekly",
          monthly: "Monthly",
        },
        ordinals: {
          first: "First",
          second: "Second",
          third: "Third",
          fourth: "Fourth",
          last: "Last",
        },
        weekdays: {
          day: "Day",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
        weekdayShort: {
          sunday: "S",
          monday: "M",
          tuesday: "T",
          wednesday: "W",
          thursday: "T",
          friday: "F",
          saturday: "S",
        },
        endTypes: {
          onDate: "On this day",
          afterOccurrences: "After",
          never: "Never",
        },
        units: {
          2: "Days",
          3: "Weeks",
          4: "Months",
          5: "Years",
        },
      },
    },
    conditions: {
      tab: "条件",
      addCondition: "条件を追加",
      conditionField: "条件フィールド",
      selectField: "\"Group / Form / Field\"を選択してください",
      operator: "オペレーター",
      rule: "Rule",
      value: "値",
      groupBy: {
        title: "グループ化",
        empty: "未設定です。クリックして設定してください。",
        configured: "設定済み: {{summary}}",
        mark: "グループ化に設定",
        limit: "最大 {{max}} 個のフィールドまで設定できます。変更はすぐに保存されます。",
        saveFailed: "グループ化の更新に失敗しました",
        foreignBlocked: "グループ化では、このテンプレートのモジュールのフィールドのみ使用できます。先に次の条件を削除してください: {{conditions}}",
        foreignVariablesBlocked: "グループ化では、このテンプレートのモジュールのフィールドのみ使用できます。先にコンテンツから次の変数を削除してください: {{variables}}",
        occurrenceConfirmTitle: "Occurrence に切り替え",
        occurrenceConfirmContent: "このテンプレートにはグループ化フィールドがあります。グループ化は Frequency にのみ適用されるため、保持されますが使用されません。続行しますか？",
      },
      regulation: {
        title: "規制条件",
        empty: "規制条件が選択されていません",
        summary: "マークされたフィールドの変更は、メール送信トリガーイベントに含まれます。",
        editAriaLabel: "規制条件を編集",
        editorDescription: "1つ以上の種類を選択してください。マークされたフィールドの変更は、メール送信トリガーイベントに含まれます。",
        clear: "クリア",
        options: {
          IDMPC: "IDMP 条件付きフィールド",
          xEVMPDC: "xEVMPD 条件付きフィールド",
          UDIC: "UDI 条件付きフィールド",
          IDMPO: "IDMP 任意フィールド",
          xEVMPDO: "xEVMPD 任意フィールド",
          UDIO: "UDI 任意フィールド",
          IDMPM: "IDMP 必須フィールド",
          xEVMPDM: "xEVMPD 必須フィールド",
          UDIM: "UDI 必須フィールド",
          SUBC: "Submission 条件付きフィールド",
          SUBO: "Submission 任意フィールド",
          SUBM: "Submission 必須フィールド",
        },
      },
      tips: {
        addAtAime: "一度に新しい行を追加できるのは1行だけです",
        addSuccess: "条件が正常に追加されました",
        updatedSuccess: "条件が正常に更新されました",
        deleteSuccess: "条件が正常に削除されました",
        regulationUpdated: "規制条件が正常に更新されました",
        regulationUpdateFailed: "規制条件の更新に失敗しました",
      }
    },
    content: {
      tab: "テンプレート内容",
      subjectTitle: "件名タイトル",
      templateTitle: "テンプレートタイトル",
      templateContent: "テンプレート内容",
      email: "メール",
      fields: "フィールド",
      tips: {
        updatedSuccess: "テンプレート内容が正常に更新されました",
      }
    },
  },
};
